export const name = 'siteUrlService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-url' as const
